import { List, Datagrid, TextField, FunctionField } from 'react-admin';

export const ActivityLogList = props => (
  <List {...props} sort={{ field: 'timestamp', order: 'DESC' }} perPage={50}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="account_id" label="Account" />
      <TextField source="event_type" label="Event" />
      <TextField source="session_id" label="Session" />
      <FunctionField
        source="event_data"
        label="Event Data"
        render={record =>
          record.event_data ? JSON.stringify(record.event_data) : '—'
        }
      />
      <TextField source="ip_address" label="IP" />
      <FunctionField
        source="timestamp"
        label="Timestamp"
        render={record =>
          record.timestamp
            ? new Date(record.timestamp).toLocaleString(undefined, { timeZoneName: 'shortOffset' })
            : '—'
        }
      />
    </Datagrid>
  </List>
);
